var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 1.25A1.75 1.75 0 0 0 .25 3v3h1v7c0 .966.783 1.75 1.75 1.75h4v-1.5H3a.25.25 0 0 1-.25-.25V6h10.5v2h1.5V6h1V3A1.75 1.75 0 0 0 14 1.25H2zM14.25 4.5V3a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25v1.5h12.5z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm6.585 3.531a.75.75 0 0 1-.117 1.055l-2.5 2a.75.75 0 0 1-.937 0l-2.5-2a.75.75 0 0 1 .937-1.172l1.282 1.026V10.5a.75.75 0 0 1 1.5 0v2.94l1.28-1.026a.75.75 0 0 1 1.055.117z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchive);
export default ForwardRef;